var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"wrap":"","justify-center":"","px-12":"","pt-2":""}},[_c('v-flex',{staticClass:"align-self-center",attrs:{"xs12":"","sm7":"","pb-12":""}},[_c('SellerRegistrationForm')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }